module.exports = __webpack_public_path__ + "img/interCom.8fd5086b.svg";